import React from 'react';
import { Request } from 'components/Request';
import { Dashboard } from 'components/Dashboard';


class HealthComponent extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			healthHovered: false,
			chargeHovered: false,
			submitting: false,
		};
		this.onMouseEnterHealth = this.onMouseEnterHealth.bind(this);
		this.onMouseLeaveHealth = this.onMouseLeaveHealth.bind(this);
		this.fakeAttackClick = this.fakeAttackClick.bind(this);
		this.chargeClick = this.chargeClick.bind(this);
		this.attackClick = this.attackClick.bind(this);
		this.defendClick = this.defendClick.bind(this);
	}

	attackClick() {
		return this.fireOff('rpg/attack');
	}

	defendClick() {
		return this.fireOff('rpg/defend');

	}

	chargeClick() {
		return this.fireOff('rpg/charge');
	}

	fakeAttackClick() {
		return this.fireOff('rpg/fake_attack');
	}

	fireOff(endPoint) {
		const { user, message } = this.props;
		const chatRoomId = message.chatMessages && message.chatMessages.chatRoom && message.chatMessages.chatRoom.id;

		const data = {
			player_id: user.id,
			chat_room_id: chatRoomId
		};
		this.setState({
			submitting: true
		});
		Request.apiv1(endPoint, data)
			.then((response) => {
				Dashboard.performOpenSearchUpdate(response);
			})
			.finally(() => {
				this.setState({
					submitting: false
				});
			});
	}

	onMouseEnterHealth() {
		this.setState({
			healthHovered: true
		});

	}

	onMouseLeaveHealth() {
		this.setState({
			healthHovered: false
		});
	}

	render() {
		const { user } = this.props;
		const { healthHovered, submitting } = this.state;

		return null;
		if(!user) {
			return null;
		}
		const hitPoints = user.hitPoints;
		if(!hitPoints) {
			return null;
		}

		const isMe = user.isMe();
		const hearts = [
			hitPoints.current >= 1 ? 'full half' : '',
			hitPoints.current >= 2 ? 'full half' : '',
			hitPoints.current >= 3 ? 'full half' : '',
		];
		return (
			<React.Fragment>
				<div className={`health_container main ${submitting ? 'disabled' : ''}`}
				     title={isMe ? 'Defend!' : 'Attack!'}
				     onMouseLeave={this.onMouseLeaveHealth}
				     onMouseEnter={this.onMouseEnterHealth}
				     onClick={isMe ? this.defendClick : this.attackClick}>
					{healthHovered && !isMe &&
					<div className='attack_display'>
						<i className={`icon fa fa-bolt ${submitting ? 'fa-spin' : ''}`} />
					</div>
					}
					{healthHovered && isMe &&
					<div className='defense_display'>
						<i className={`icon fa fa-shield ${submitting ? 'fa-spin' : ''}`} />
					</div>
					}
					{!healthHovered &&
					hearts.map((heart, index) => {
							return (
								<span key={index} className='heart_holder'>
				                    <span className={`heart ${heart}`} />
				                </span>
							);
						}
					)}
				</div>
				{isMe &&
				<div title='Begin Charging!' className={`health_container special ${submitting ? 'disabled' : ''}`}
				     onClick={this.chargeClick}>
					<div className='attack_display'>
						<i className={`icon fa fa-bolt ${submitting ? 'fa-spin' : ''}`} />
					</div>
				</div>
				}
				{!isMe &&
				<div title='Feign Attack!' className={`health_container special ${submitting ? 'disabled' : ''}`}
				     onClick={this.fakeAttackClick}>
					<div className='attack_display'>
						<i className={`icon fa fa-tree ${submitting ? 'fa-spin' : ''}`} />
					</div>
				</div>
				}
			</React.Fragment>
		);
	}
}

export { HealthComponent };